module.exports = __webpack_public_path__ + "img/1495305450.1f23757c.jpg";